var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-container',{attrs:{"title":_vm.title}},[_c('div',{staticClass:"mc-list-fold"},[_c('ul',{staticClass:"mc-list-fold__ul",style:({
          height: _vm.foldHeight
        })},[_vm._t("default")],2),_vm._v(" "),(_vm.maxLine > _vm.minLine)?_c('footer',{staticClass:"mc-list-fold__footer"},[_c('p',[(_vm.fold)?[_vm._v("查看全部")]:[_vm._v("收起")]],2),_vm._v(" "),_c('span',{class:{
            'is-open': _vm.fold,
            'is-close': !_vm.fold
          },on:{"click":_vm._toggle}},[_c('i',{staticClass:"fa fa-angle-up"})])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-list-fold.vue